module.exports = __webpack_public_path__ + "static/media/logo_agcu.da8bf9a0.png";